"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateContactDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const update_address_dto_1 = require("../../address/dto/update-address.dto");
const update_contact_details_dto_1 = require("./update-contact-details.dto");
const update_professional_experience_dto_1 = require("./update-professional-experience.dto");
const update_qualification_experience_dto_1 = require("./update-qualification-experience.dto");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const update_contact_communication_details_dto_1 = require("./update-contact-communication-details.dto");
const update_document_dto_ts_1 = require("./update-document.dto.ts");
const common_1 = require("@nestjs/common");
class UpdateContactDto {
}
exports.UpdateContactDto = UpdateContactDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Salutation ID of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "First name of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "First name must not exceed 100 characters." }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Last name of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Last name must not exceed 100 characters." }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Middle name of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Middle name must not exceed 100 characters." }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "middleName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Display name of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Display name must not exceed 100 characters." }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Company ID associated with the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company location ID", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company Location id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "companyLocationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Relationship Type ID", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Relationship type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "relationshipTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company branch ID", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company Branch id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "companyBranchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Tag ID associated with the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Tag id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "tagLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Contact type ID", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "contactTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Department of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "department must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "department should not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Designation of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "department must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "department should not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Reporting to ID", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "reporting id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "reportingToId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Remarks about the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Contact remarks must not exceed 1000 characters ");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Contact LinkedIn URL", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/, {
        message: "Invalid LinkedIn URL format.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDto.prototype, "linkedInUrl", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateContactDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of addresses associated with the contact",
        type: [update_address_dto_1.UpdateAddressDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_address_dto_1.UpdateAddressDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDto.prototype, "address", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact details associated with the contact",
        type: update_contact_details_dto_1.UpdateContactDetailsDto,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => update_contact_details_dto_1.UpdateContactDetailsDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof update_contact_details_dto_1.UpdateContactDetailsDto !== "undefined" && update_contact_details_dto_1.UpdateContactDetailsDto) === "function" ? _b : Object)
], UpdateContactDto.prototype, "contactDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of professional experiences associated with the contact",
        type: [update_professional_experience_dto_1.UpdateProfessionalExperienceDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_professional_experience_dto_1.UpdateProfessionalExperienceDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDto.prototype, "professionalExperiences", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of qualification experiences associated with the contact",
        type: [update_qualification_experience_dto_1.UpdateQualificationExperienceDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_qualification_experience_dto_1.UpdateQualificationExperienceDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDto.prototype, "qualificationExperiences", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_contact_communication_details_dto_1.UpdateContactCommunicationDetailsDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDto.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of documents associated with the contact",
        type: [update_document_dto_ts_1.UpdateDocumentDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_document_dto_ts_1.UpdateDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDto.prototype, "contactDocMaps", void 0);
